// extracted by mini-css-extract-plugin
export default {"form":"ProfileForm_form__3RMfh","field":"ProfileForm_field__vNJzU","label":"ProfileForm_label__IFZO2","errorText":"ProfileForm_errorText__oj972"};